import menu from "./menu";
import list from "./list";

export default {
    menu,
    list
}